import React from 'react';
import './President.css';
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import PageHeader from '../../components/PageHeader/PageHeader';
import presiImg from '../../assets/images/president/presidennt.jpeg';
import presiSideImg from '../../assets/images/president/presi.jpeg';
import hortiImg from '../../assets/images/programs/horticulture/pic3.png';

const President: React.FC = () => {
    return (
        <div className="president-page">
            <Navbar />
            <PageHeader 
                title="President & CEO" 
                path="/president" 
                name="President" 
                backgroundImage={hortiImg} 
            />
            
            <div className="president-content">
                <div className="container">
                    <div className="president-header-info text-center mb-5">
                        <h1 className="president-name">MR. ISAAC AGYIRI</h1>
                        <p className="president-subtitle">CEO and Founder, Showbouys Foundation</p>
                        <div className="president-social-links">
                            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer"><i className="fab fa-facebook-f"></i></a>
                            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer"><i className="fab fa-twitter"></i></a>
                            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer"><i className="fab fa-linkedin-in"></i></a>
                            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer"><i className="fab fa-instagram"></i></a>
                        </div>
                    </div>

                    <div className="president-article intro-article">
                        <div className="article-image-wrap float-lg-end ms-lg-4 mb-4">
                            <img src={presiImg} alt="Mr. Isaac Agyiri" className="article-img" />
                            <p className="img-caption">Mr. Isaac Agyiri - Founder & President</p>
                        </div>

                        <p className="lead-text">
                            Mr. Isaac Agyiri is a distinguished Ghanaian educator, entrepreneur, farmer, and humanitarian whose work continues to inspire and transform lives across communities in Ghana.
                        </p>
                        
                        <p>
                            Born on 21st September 1983 in the Central Region of Ghana, he is widely recognized for his passion for youth empowerment, sustainable agriculture, environmental stewardship, and community development.
                        </p>

                        <p>
                            As the Founder and President of the Showbouys Foundation, Mr. Agyiri has dedicated his life to creating opportunities for young people through practical agricultural training, mentorship, and entrepreneurship development. With a strong academic background in Mathematics, holding a Diploma and Bachelor of Science degree in Mathematics, he combines education with innovation to drive impactful social change.
                        </p>
                    </div>
                </div>

                <div className="president-vision-section">
                    <div className="container-fluid p-0">
                        <div className="row g-0 align-items-center">
                            <div className="col-lg-6">
                                <div className="vision-image">
                                    <img src={presiSideImg} alt="Office of the President" />
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="vision-text-side">
                                    <h2>Vision & Leadership</h2>
                                    <p>
                                        The President is responsible for championing agroecology and food security to empower over 10,000 Ghanaian youth. 
                                        His leadership is dedicated to creating a future of self-reliance, innovation, and sustainable economic growth across rural communities.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="container">
                    <div className="president-article">
                        <p>
                            Mr. Agyiri is also the brain behind the establishment of Showbouy School Agroecology Fun Clubs, an initiative aimed at promoting environmental awareness, experiential learning, and sustainable farming practices in schools across Ghana. Through these initiatives, he has consistently encouraged young people to embrace agriculture as a viable path to economic empowerment and national development.
                        </p>

                        <p>
                            In addition to his philanthropic activities, he operates a large-scale seedling nursery and agroecology practical training center through Showbouy Farms. His centers have provided internship and practical attachment opportunities for several secondary and tertiary students, helping bridge the gap between education and industry experience.
                        </p>

                        <div className="awards-strip my-5">
                            <div className="row g-4">
                                <div className="col-md-4">
                                    <div className="award-item">
                                        <i className="fas fa-award"></i>
                                        <h4>Overall Best Teacher</h4>
                                        <p>Agriculture (2023)</p>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="award-item">
                                        <i className="fas fa-trophy"></i>
                                        <h4>Best Farmer</h4>
                                        <p>Twifo-Atti Morkwa (2020)</p>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="award-item">
                                        <i className="fas fa-star"></i>
                                        <h4>Influential Youth Mentor</h4>
                                        <p>Central Region (2024)</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <p>
                            He has actively contributed to environmental restoration efforts by distributing seedlings and organizing sensitization programs on land restoration and agroecology, particularly in communities affected by illegal mining activities.
                        </p>

                        <p>
                            Known for his optimism, visionary leadership, and commitment to humanity, Mr. Agyiri continues to champion initiatives that create employment opportunities for women and youth while promoting sustainable agricultural practices and environmental conservation. His long-term goal is to expand agribusiness opportunities, strengthen partnerships with organizations and institutions, and build a future where young people can thrive through innovation, agriculture, and entrepreneurship.
                        </p>
                    </div>
                </div>
            </div>

            <Footer />
        </div>
    );
};

export default President;
